import _ from 'lodash'
import { bookingConstants, bookingStatus } from 'utils/constants/booking-constants'
import FetchTimeslotCapacity from 'utils/fetch/FetchTimeslotCapacity'
import ObjectBooking from 'utils/objects/booking'
import i18n from 'utils/i18n'
import { cartConstants } from 'services/redux/cart/constants'
import store from 'services/redux/store'
import { dataConstants } from 'services/redux/data/constants'
import { selectCartEmployees } from 'services/redux/cart/reducers'
import ObjectTimeslot from 'utils/objects/timeslot'
import GraphqlBuilder from 'utils/request/graphql/builder'
import MutationEmployeeBookingInvitation from 'graphql/mutations/MutationEmployeeBookingInvitation'
import HelperAlerts from 'utils/HelperAlerts'
import MutationEmployeeExternal from 'graphql/mutations/MutationEmployeeExternal'
import MutationEmployeeBookingStatus from 'graphql/mutations/MutationEmployeeBookingStatus'
import { constantsActive } from 'utils/constants/constants'
import MutationEmployeeBooking from 'graphql/mutations/MutationEmployeeBooking'
import FetchCachedBookingInvitationSent from 'utils/fetch/cached/FetchCachedBookingInvitationSent'
import FetchCachedMyBooking from 'utils/fetch/cached/FetchCachedMyBooking'
import { removeCartTimeslots } from 'services/redux/cart/actions'
import { SET_CART } from 'services/redux/action-types'
import HelperString from 'utils/helper-string'

export default class ValidateBookingFunctions {
	
	static createFlatList( bookingList ) {
		const result = {};
		
		_.forEach( bookingList, (booking, key) => {
			const { isInvitation, isInviter, invitation } = ObjectTimeslot.collect( booking );
			
			booking._invitation = null;
			
			// ONLY when I'm the inviter (only inviter may add others)
			if( isInvitation && isInviter ) {
				booking._invitation = invitation;
			}
			
			result[ key ] = booking;
		})
		
		return result;
	}
	
	static createInvitation = ({ values, showInvitees, employeeStatus, bookForOption, onSetEmployeeStatus,  onSuccess, onError }) => {
		const _bookingExternalPersons = store.getState().cart[ cartConstants.BOOKING_EXTERNAL_PERSONS ];
		
		new GraphqlBuilder()
			.addQuery( 'mutation_employee_booking_invitation', MutationEmployeeBookingInvitation, {
				name: _.get( values, 'name', null ),
				description: _.get( values, 'description', null ),
				show_invitees: showInvitees ? 'yes' : 'no'
			} )
			.setOnSuccess( result => {
				const invitationGuid = _.get( result, ['mutation_employee_booking_invitation', 'employee_booking_invitation', 'guid'], null );
				
				// No guid?? ERROR
				if( invitationGuid === null ) {
					this.graphqlOnError( result , { error: 'no_invitation_guid', onError } );
					return;
				}
				
				// When externals -> create them
				if( _.size( _bookingExternalPersons ) > 0 ) {
					this.createExternalEmployee({
						values: values,
						invitationGuid: invitationGuid,
						bookForOption: bookForOption,
						employeeStatus: employeeStatus,
						onSetEmployeeStatus: onSetEmployeeStatus,
						onSuccess: onSuccess,
						onError: onError
					});
					return;
				}
				
				// Create the bookings
				this.createBookings({
					values: values,
					employeeStatus: employeeStatus,
					bookForOption: bookForOption,
					invitationGuid: invitationGuid,
					onSuccess: onSuccess,
					onError: onError
				})
			})
			.setOnError( this.graphqlOnError )
			.execute()
	}
	
	static createExternalEmployee = ({ values, employeeStatus, onSetEmployeeStatus, bookForOption, invitationGuid, onSuccess, onError }) => {
		const _bookingExternalPersons = store.getState().cart[ cartConstants.BOOKING_EXTERNAL_PERSONS ];
		
		const queryPrefix = 'mutation_external_empoloyee-';
		
		const builder = new GraphqlBuilder();
		
		// Add the queries
		_.forEach( _bookingExternalPersons, (external, k) => {
			if( _.get( external, 'created', false ) === false ) {
				builder.addQuery( `${queryPrefix}${k}`, MutationEmployeeExternal, {
					name: external.name,
					email: external.email
				});
			}
		});
		
		// On success
		builder.setOnSuccess( result => {
			let newBookingExternalPersons = {
				..._bookingExternalPersons
			}
			
			_.forEach( result, (employee, key) => {
				employee = _.get( employee, 'employee_external', null );
			
				if( employee !== null ) {
					// Check the old key
					const oldExternalKey = key.split( queryPrefix ).pop();
					
					if( !HelperString.isEmptyString( oldExternalKey ) ) {
						// Create with the new guid
						newBookingExternalPersons[ employee.guid ] = {
							...newBookingExternalPersons[ oldExternalKey ],
							created: true,
							guid: employee.guid
						}
						
						// remove the old key
						delete newBookingExternalPersons[ oldExternalKey ]
					}
				}
			});
			
			// Update the state
			store.dispatch({
				type: SET_CART,
				key: cartConstants.BOOKING_EXTERNAL_PERSONS,
				payload: newBookingExternalPersons
			})
			
			this.createBookings( {
				values: values,
				employeeStatus: employeeStatus,
				invitationGuid: invitationGuid,
				bookForOption: bookForOption,
				onSuccess: onSuccess,
				onError: onError
			} )
		});
		
		// On error
		builder.setOnError( this.graphqlOnError )
		
		//return;
		builder.execute();
	}
	
	static createBookingReferences = {};
	static createBookings = ( { values, invitationGuid = null, employeeStatus = {}, bookForOption = {}, onSuccess, onError } = {} ) => {
		const _employee = store.getState().data[ dataConstants.EMPLOYEE ];
		
		const _cartTimeslotsLunchOptions = store.getState().cart[ cartConstants.TIMESLOTS_LUNCH_OPTIONS ];
		const _cartTimeslotsTransportLicensePlates = store.getState().cart[ cartConstants.TIMESLOTS_TRANSPORT_LICENSE_PLATES ];
		const _cartBookingReject = store.getState().cart[ cartConstants.BOOKING_REJECT ];
		
		// Reset
		this.createBookingReferences = {};
		
		// Create the employee list
		const _cartBookings = store.getState().cart[ cartConstants.TIMESLOTS ];
		const _cartEmployees = selectCartEmployees( store.getState() );
		
		// Add existing
		const employees = [];
		_.forEach( _cartEmployees, coworker => {
			employees.push( coworker.guid );
		});
		
		// Store the bookings
		const graphqlBuilder = new GraphqlBuilder();
		
		// Create the queries
		_.forEach( employees, employeeGuid => {
			// Check if the current employee is the booker
			const isBooker = ( employeeGuid === _employee.guid );
			
			_.forEach( this.createFlatList( _cartBookings ), booking => {
				const keyByBooking = FetchTimeslotCapacity.keyByBooking( booking );
				
				// Check if we are the booker
				if( isBooker ) {
					if( ObjectBooking.didAlreadyBook([ booking ] ) ) {
						return;
					}
				}
				
				// Init
				let mutation = MutationEmployeeBookingStatus;
				let parameters = {
					guid: booking.guid,
					active: constantsActive.YES,
					status: bookingStatus.INVITE_ACCEPTED
				};
				
				// Is invitation
				const isInvitation = ObjectBooking.isInvitation( booking );
				
				if( !isInvitation ) {
					// Create new booking
					mutation = MutationEmployeeBooking;
					
					parameters = {
						employee_guid: employeeGuid,
						kind: booking?.kind,
						booking_date: booking.booking_date,
						building_guid: _.get( booking, ['building', 'guid'], null ),
						floor_guid: _.get( booking, ['floor', 'guid'], null ),
						room_guid: _.get( booking, ['room', 'guid'], null ),
						table_guid: _.get( booking, ['table', 'guid'], null ),
						timeslot_guid: _.get( booking, ['timeslot', 'guid'], null ),
						building_parking_space_guid: null,
						lunch_option_guids: [],
						transport_kind: null,
						reason: _.get( values, 'reason', null ),
					};
					
					if( _.includes( Object.keys( employeeStatus ), employeeGuid ) ) {
						parameters[ 'status' ] = bookingStatus.INVITE_ACCEPTED;
					}
					
					// Add the invitation (when needed)
					if( booking._invitation !== null ) {
						parameters['employee_booking_invitation_guid'] = booking._invitation.guid;
						
					} else {
						if( invitationGuid !== null ) {
							parameters['employee_booking_invitation_guid'] = invitationGuid;
						}
					}
				}
				
				// Timeslot lunch options
				switch( booking?.kind ) {
					case bookingConstants.LUNCH:
						// Only add the lunch option for the one who is booking
						const timeslotLunchOption = _.get( _cartTimeslotsLunchOptions, [ keyByBooking, employeeGuid ], null );
						
						if( timeslotLunchOption !== null ) {
							parameters.lunch_option_guids = [ timeslotLunchOption ];
						}
						break;
						
					case bookingConstants.TRANSPORT:
						parameters.transport_kind = _.get( booking, ['transport_kind'], null );
						parameters.building_parking_space_guid = _.get( booking, ['building_parking_space', 'guid'], null );
						
						const license_plate = _.get( _cartTimeslotsTransportLicensePlates, [ keyByBooking, employeeGuid ], null );
						if( license_plate !== null ) {
							parameters.license_plate = license_plate;
						}
						break;
				}
				
				// Set name and add the query
				const mutationName = this.getMutationName( employeeGuid, booking );
				graphqlBuilder.addQuery( mutationName, mutation, parameters );
				
				// Store the key
				this.createBookingReferences[ mutationName ] = keyByBooking;
			});
			
			// When the employee is the booker and there are timeslots to be reject
			// Add a mutation to reject them
			if( isBooker ) {
				if( _.size( _cartBookingReject ) > 0 ) {
					_.forEach( _cartBookingReject, bookingReject => {
						const keyByBooking = FetchTimeslotCapacity.keyByBooking( bookingReject );
						
						const parameters = {
							guid: bookingReject.guid,
							active: constantsActive.NO,
							status: bookingStatus.INVITE_REJECTED
						};
						
						const mutationName = this.getMutationName( employeeGuid, bookingReject );
						graphqlBuilder.addQuery( mutationName, MutationEmployeeBookingStatus, parameters );
						
						// Store the key
						this.createBookingReferences[ mutationName ] = keyByBooking;
					})
				}
			}
		});
		
		// Add the onSuccess
		graphqlBuilder.setOnSuccess( result => {
			const failedRequests = [];
			
			const bookings = [];
			_.forEach( result, (booking, bookingKey) => {
				
				const itemBooking = {
					..._.get( booking, 'create_employee_booking', {} ),
					..._.get( booking, 'employee_booking', {} ),
					bookingKey: bookingKey
				};
				
				if( !_.isEmpty( itemBooking.guid ) ) {
					bookings.push( itemBooking );

					// This booking was successful, so we can remove the booking from the cart
					store.dispatch( removeCartTimeslots( _.get( this.createBookingReferences, itemBooking.bookingKey, null ) ) )
					
					// And remove the query
					graphqlBuilder.removeQuery( itemBooking.bookingKey );
				} else {
					failedRequests.push( bookingKey );
				}
			});
			
			// Check if we have failed requests..
			if( _.size( failedRequests ) > 0 ) {
				
				// Then return the error.
				this.graphqlOnError( result, { error: 'mutation_failed', onError } );
				return;
			}
			
			this.fetchSavedBookings({
				bookings: bookings,
				onSuccess: onSuccess,
				onError: onError
			});
		})
		
		/// Also set the onError
		graphqlBuilder.setOnError( this.graphqlOnError )
		
		// When there are queries added
		if( _.size( graphqlBuilder.queries ) > 0 ) {
			graphqlBuilder.execute();
		}
	}
	
	static fetchSavedBookings = ({ bookings = [], onSuccess, onError }) => {
		FetchCachedBookingInvitationSent.reload();
		
		if( !_.isEmpty( bookings ) ) {
			FetchCachedMyBooking.reload({
				callbackSuccess: onSuccess,
				callbackError: onError
			})
		} else {
			if( _.isFunction( onSuccess ) ) {
				onSuccess();
			}
		}
	}
	
	static getMutationName = ( employee, booking ) => {
		return `${employee}-${booking?.kind}-${booking?.timeslot?.guid}`;
	}
	
	static graphqlOnError = ( result, { error, onSuccess, onError } ) => {
		HelperAlerts.alert(
			i18n.t('page.create.overview.save.alert_title'),
			i18n.t('page.create.overview.save.alert_message'),
		);
		
		if( _.isFunction( onError ) ) {
			onError();
		}
	}
	
	static updateEmployeeStatus = ( statuses, employee ) => {
		const employeeGuid = employee.guid;
		
		let newEmployeeStatus = {
			...statuses,
		};
		
		switch( true ) {
			case _.has( newEmployeeStatus, employeeGuid ):
				delete newEmployeeStatus[ employeeGuid ];
				break;
				
			default:
				newEmployeeStatus[ employeeGuid ] = bookingStatus.INVITE_ACCEPTED;
		}
		
		return newEmployeeStatus
	}
}
